import { type JSX } from "react";
import {
  type CatalogTaxonomySelection,
  type SearchFilterCatalogFields,
} from "./search-filter.props";

interface CatalogEditingHintProps {
  heading: string;
  datasource: NonNullable<SearchFilterCatalogFields["data"]>["datasource"];
  stylesParam?: string;
}

const renderTaxonomyList = (
  label: string,
  items: CatalogTaxonomySelection[] | undefined,
): JSX.Element | null => {
  if (!items || items.length === 0) return null;
  return (
    <p>
      <strong>{label}:</strong>{" "}
      {items
        .map((item) => item.taxonomyLabel.value ?? "")
        .filter(Boolean)
        .join(", ")}
    </p>
  );
};

export const CatalogEditingHint = ({
  heading,
  datasource,
  stylesParam,
}: CatalogEditingHintProps): JSX.Element => (
  <div className={`is-metadata-hint ${stylesParam ?? ""}`}>
    <p>
      <strong>{heading}</strong>
    </p>
    {renderTaxonomyList("Applications", datasource?.applications?.targetItems)}
    {renderTaxonomyList("Solutions", datasource?.solutions?.targetItems)}
    {renderTaxonomyList("Industries", datasource?.industries?.targetItems)}
    {renderTaxonomyList("Markets", datasource?.markets?.targetItems)}
  </div>
);
